import { FormControl, FormLabel, Textarea } from '@chakra-ui/react';

function setProjectDescription({ e, projectInfo, setProjectInfo }) {
	const value = e.target.value;
	const newProjectInfo = { ...projectInfo };
	newProjectInfo.description = value;
	setProjectInfo(newProjectInfo);
}

const CreateSaveProjectDescription = ({ projectInfo, setProjectInfo }) => {
	return (
		<FormControl mb={6}>
			<FormLabel fontWeight={700} fontSize={'xs'}>
				Descrição
			</FormLabel>
			<Textarea
				maxLength="255"
				defaultValue={projectInfo.description}
				onChange={(e) => setProjectDescription({ e, projectInfo, setProjectInfo })}
				fontSize="14px"
				placeholder="Digite a descrição do projeto (max. 255 caracteres)"
			></Textarea>
		</FormControl>
	);
};

export default CreateSaveProjectDescription;
